import {ofType} from 'redux-observable';
import {flatMap, catchError} from 'rxjs/operators';
import {of} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';
import {createOrUpdateObservable} from 'web-app/react/entities/bill-payers/epics';
import {
    createVoucherObservable,
    updateVoucherObservable,
    deletePaymentObservable,
} from 'web-app/react/entities/recurring-payments/epics';
import * as AccountItemActions from 'web-app/react/entities/account-items/actions';
import {hasValue} from '@famly/stat_ts-utils_has-value';

import * as Actions from './actions';

const save = action$ =>
    action$.pipe(
        ofType(Actions.save.type),
        flatMap(({payload}: ReturnType<typeof Actions.save.action>) => {
            const {institutionId, billPayerId, payment, voucherCompany} = payload;
            const voucherCompanyFromPayment = payment.voucherCompany;

            if (hasValue(voucherCompanyFromPayment)) {
                return createVoucherObservable(institutionId, billPayerId, {
                    recurringPayment: {
                        ...payment,
                        voucherCompany: voucherCompanyFromPayment,
                    },
                }).pipe(
                    flatMap(successAction => [
                        successAction,
                        AccountItemActions.fetchBillPayerBalance.action(institutionId, billPayerId),
                        Actions.saveSuccess.action(),
                    ]),
                    catchError(e => of(Actions.saveFailed.action(e))),
                );
            }
            return createOrUpdateObservable(institutionId, null, voucherCompany).pipe(
                flatMap(billPayerSuccess => {
                    return createVoucherObservable(institutionId, billPayerId, {
                        recurringPayment: {
                            ...payment,
                            voucherCompany: {
                                voucherCompanyId: billPayerSuccess.payload.billPayer.billPayerId,
                            },
                        },
                    }).pipe(
                        flatMap(successAction => [
                            successAction,
                            billPayerSuccess,
                            AccountItemActions.fetchBillPayerBalance.action(institutionId, billPayerId),
                            Actions.saveSuccess.action(),
                        ]),
                    );
                }),
                catchError(e => {
                    return of(Actions.saveFailed.action(e));
                }),
            );
        }),
    );

const update = action$ =>
    action$.pipe(
        ofType(Actions.update.type),
        flatMap(({payload}: ReturnType<typeof Actions.update.action>) => {
            const {institutionId, billPayerId, recurringPaymentId, voucher} = payload;
            return updateVoucherObservable(institutionId, billPayerId, recurringPaymentId, voucher).pipe(
                flatMap(successAction => [
                    successAction,
                    AccountItemActions.fetchBillPayerBalance.action(institutionId, billPayerId),
                    Actions.updateSuccess.action(),
                ]),
                catchError(e => of(Actions.updateFailed.action(e))),
            );
        }),
    );

const deleteVoucher = action$ =>
    action$.pipe(
        ofType(Actions.deleteVoucher.type),
        flatMap(({payload}: ReturnType<typeof Actions.deleteVoucher.action>) => {
            const {institutionId, billPayerId, recurringPaymentId} = payload;
            return deletePaymentObservable(institutionId, billPayerId, recurringPaymentId).pipe(
                flatMap(successAction => [
                    successAction,
                    AccountItemActions.fetchBillPayerBalance.action(institutionId, billPayerId),
                    Actions.deleteVoucherSuccess.action(),
                ]),
                catchError(e => of(Actions.deleteVoucherFailed.action(e))),
            );
        }),
    );

export default combineEpics(save, update, deleteVoucher);
